import { Box } from "@mui/material";
import { TitleSection } from "../../components/TitleSection";
import { VerticalSlider } from "../../components/sliderPage/verticalSlider";
import CircularProgressBar from "./CircularProgressBar";

export const SecLanguages = () => {
  const sxProps = {
    height: "300px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <>
      <VerticalSlider />
      <Box
        id={"languages"}  
        sx={{
          "& .progress-container": {
            position: "relative",
            display: "flex",
          },
          "& .circular-bg": {
            stroke: "var(--c-main-color-hover)",
          },
          "& .circular-progress-bar": {
            border: "5px solid var(--c-bg-content-color)",
            stroke: "var(--c-second-color-hover)",
            transition: "stroke-dashoffset 0.35s",
            transform: "rotate(-90deg)",
            transformOrigin: "50% 50%",
          },
          "& .progress-text": {
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            color: "var(--c-text-color)",
            boxShadow: "-3px -3px 5px 0px rgba(255,255,255,0.1), 5px 5px 5px 0px rgba(0,0,0,0.1), inset -5px -5px 5px -5px rgba(255, 255, 255, 0.1), inset 5px 5px 5px 0px rgba(0, 0, 0, 0.1)",
          },
          paddingX: {
            xs: "25px",
            sm: "50px",
            md: "70px",
          },
          mt: "86px",
        }}
      >
        <Box sx={{ mb: "20px" }}>
          <TitleSection title={"Languages"} value={68} />
        </Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          <Box sx={{ flex: "0 1 100%", ...sxProps }}>
            <CircularProgressBar
              percentage={98}
              label="Ukrainian"
              level="Native"
            />
          </Box>
          <Box
            sx={{
              flex: {
                xs: "0 1 100%",
                md: "0 1 50%",
              },
              ...sxProps,
            }}
          >
            <CircularProgressBar
              percentage={30}
              label="English"
              level="Pre-Intermediate"
            />
          </Box>
          <Box
            sx={{
              flex: {
                xs: "0 1 100%",
                md: "0 1 50%",
              },
              ...sxProps,
            }}
          >
            <CircularProgressBar
              percentage={93}
              label="Russian"
              level="Proficiency"
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};
